exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-link{text-decoration:none!important;font-size:14px!important;color:#5b6981!important}.btn-link:hover{color:#38404f;text-decoration:none}.dropdown-menu.show{background-color:#fff;padding:4px;margin-top:4px;border:1px solid #eaedf3;-webkit-box-shadow:2px 4px 8px rgba(153,155,168,.2);box-shadow:2px 4px 8px rgba(153,155,168,.2)}.dropdown-menu.show .dropdown-item{font-size:14px;line-height:20px;font-weight:400;color:#5b6981;border-radius:2px;padding:4px 8px;height:28px}.dropdown-menu.show .dropdown-item:hover{background-color:#f4f7ff;color:#4d7cfe}", ""]);

// exports
